module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp14-3c04f50dfe87c19f53b173198e44930d.jpg";